import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { IExpirationSettings } from "@app/shared/expiration-settings/interfaces/expiration-settings.interface";
import { OcrQuotationExpirationSettingsApiService } from "@app/shared/ocr-quotation-expiration-settings/services/ocr-quotation-expiration-settings-api.service";

export const ocrQuotationExpirationSettingsResolver: ResolveFn<IExpirationSettings[]> = (route, _) => {
  const ocrQuotationExpirationSettingsApiService = inject(OcrQuotationExpirationSettingsApiService);
  return ocrQuotationExpirationSettingsApiService.getOcrQuotationExpirationSettings();
};
